import React, { useState, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function Menu() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const toggleMenu = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  const closeMenu = useCallback(() => {
    setIsOpen(false);
  }, []);

  const handleHashLink = useCallback((hash, e) => {
    e.preventDefault();
    e.stopPropagation();

    // Close menu immediately
    setIsOpen(false);

    // Get current pathname at the time of execution
    const currentPath = window.location.pathname;

    // Use setTimeout to ensure menu closes and state updates before navigation
    setTimeout(() => {
      if (currentPath !== '/') {
        navigate(`/${hash}`);
      } else {
        const element = document.querySelector(hash);
        if (element) {
          // Scroll to element
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          // Update URL hash without triggering navigation
          window.history.pushState(null, '', hash);
        }
      }
    }, 50);
  }, [navigate]);

  return (
    <div className="menu-wrapper">
      <button
        className={`menu-toggle ${isOpen ? 'menu-toggle--open' : ''}`}
        onClick={toggleMenu}
        aria-label={isOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={isOpen}
        aria-controls="primaryNav"
      >
        <span className="menu-line" />
        <span className="menu-line" />
        <span className="menu-line" />
      </button>

      {isOpen && (
        <div className="menu-backdrop" onClick={closeMenu} aria-hidden="true" />
      )}

      <nav
        id="primaryNav"
        className={`menu ${isOpen ? 'menu--open' : ''}`}
        aria-label="Main navigation"
      >
        <ul className="menu-list">
          <li className="menu-item">
            <a
              href="/"
              className="menu-link"
              onClick={closeMenu}
            >
              <span className="menu-link-text">HOME</span>
              <span className="menu-link-dots"></span>
            </a>
          </li>
          <li className="menu-item">
            <a
              href="#about"
              className={`menu-link ${location.hash === '#about' || (location.pathname === '/' && !location.hash) ? 'menu-link--active' : ''}`}
              onClick={(e) => handleHashLink('#about', e)}
            >
              <span className="menu-link-text">ABOUT</span>
              <span className="menu-link-dots"></span>
            </a>
          </li>
          <li className="menu-item">
            <a
              href="#work"
              className={`menu-link ${location.hash === '#work' ? 'menu-link--active' : ''}`}
              onClick={(e) => handleHashLink('#work', e)}
            >
              <span className="menu-link-text">WORK</span>
              <span className="menu-link-dots"></span>
            </a>
          </li>
          <li className="menu-item">
            <a
              href="#contact"
              className={`menu-link ${location.hash === '#contact' ? 'menu-link--active' : ''}`}
              onClick={(e) => handleHashLink('#contact', e)}
            >
              <span className="menu-link-text">CONTACT</span>
              <span className="menu-link-dots"></span>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  );
}

